import { render, staticRenderFns } from "./registrierung.vue?vue&type=template&id=829097bc&scoped=true&"
import script from "./registrierung.vue?vue&type=script&lang=js&"
export * from "./registrierung.vue?vue&type=script&lang=js&"
import style0 from "./registrierung.vue?vue&type=style&index=0&id=829097bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829097bc",
  null
  
)

export default component.exports